import {FileUpload} from './FileUpload.js'
export default function Test1(){
    return(
        <div>
            <div>
                <FileUpload />
            </div>            
        </div>

    )
}